// @flow
import { error } from './common';
import * as types from '../types/gatewayUserActions';
import type { GATEWAY_USER_ACTION_TYPE, GATEWAY_USER_ACTION_FETCH_SUCCESS_TYPE } from '../types/gatewayUserActions';

export const gatewaysUserActionFetchSucceed = (
  entities: {[number]: GATEWAY_USER_ACTION_TYPE},
  order: Array<number>,
): GATEWAY_USER_ACTION_FETCH_SUCCESS_TYPE => ({
  type: types.GATEWAY_USER_ACTION_FETCH_SUCCESS,
  payload: {
    entities,
    order,
  },
});

export const gatewayUserActionFetchFailed = error(types.GATEWAYS_USER_ACTION_FETCH_FAILED);



// WEBPACK FOOTER //
// ./src/scripts/actions/gatewayUserActions.js